import React from 'react';
import { useForm } from 'react-hook-form';

import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import { Typography, Box, TextField } from '@mui/material';
import toast from 'react-hot-toast';

import { validatePassword } from '../utils';

export default function ResetPassword({ handleClose, onSubmit, isLoading }) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
  } = useForm({});

  const onFormSubmit = (submittedData) => {
    if (!submittedData.currentPassword || !submittedData.password || !submittedData.confirmPassword) {
      toast.error('Please fill out all required fields');
      return;
    }

    onSubmit({
      currentPassword: submittedData.currentPassword,
      newPassword: submittedData.password,
    });
    reset();
  };

  return (
    <Box
      sx={{
        height: 'fit-content',
        width: '100%',
        boxShadow: (theme) => theme.palette.mode === 'dark' ? '0px 2px 6px 0px rgba(0, 0, 0, 0.3)' : '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
        borderRadius: '20px',
        mx: 'auto',
        bgcolor: 'background.paper',
        color: 'text.primary',
        p: '30px',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '20px' }}>

      <Typography variant="h4" sx={{ textAlign: 'center', color: 'text.titles',  }}>
        Change Password
      </Typography>
      <Box sx={{ textAlign: 'right' }}>
        <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
      </Box>
      </Box>

      <form onSubmit={handleSubmit(onFormSubmit)}>
        <TextField
          name="currentPassword"
          label="Current Password *"
          fullWidth
          {...register('currentPassword', {
            required: `Current Password is required`,
          })}
          error={errors && !!errors?.currentPassword}
          helperText={errors?.currentPassword?.message}
          type="password"
          autoComplete="on"
        />

        <TextField
          name="password"
          label="New Password *"
          fullWidth
          {...register('password', {
            required: true,
            validate: validatePassword,
          })}
          error={errors && !!errors?.password}
          helperText={errors?.password?.message}
          type="password"
          autoComplete="on"
          sx={{ my: '20px' }}
        />
        <TextField
          name="confirmPassword"
          label="Confirm Password *"
          fullWidth
          {...register('confirmPassword', {
            required: `This is required`,
            validate: (value) => {
              if (watch('password') !== value) {
                return 'Passwords should match!';
              }
              if (watch('currentPassword') === value) {
                return 'Current and New Passwords should not be Same';
              }
              return null;
            },
          })}
          error={errors && !!errors?.confirmPassword}
          helperText={errors?.confirmPassword?.message}
          type="password"
          autoComplete="on"
        />

        <LoadingButton
          loading={isLoading}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, maxWidth: '118px' }}
          color="main"
        >
          Submit
        </LoadingButton>
      </form>
    </Box>
  );
}
